import React, { useContext, useState } from 'react';
import './Permission.module.scss';
import Button from 'components/UI/Button';
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { Tooltip } from 'react-tippy';
import { QuizContext } from 'screens/Quiz/Quiz';
import { faCheck, faThoughtBubble } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ProgressBar from '../../ProgressBar/ProgressBar';
import CircleButton from '../../CircleButton/CircleButton';
// import TeachingCard from './components/TeachingCard/TeachingCard';

const buttons = [
    {
        icon: faCheck,
        description: 'Ja, heb ik al',
        answerLabel: 'yes',
    },
    {
        icon: faThoughtBubble,
        description: 'Nee, nog niet',
        answerLabel: 'no',
    },
];

export default function Permission() {
    const [activeButton, setActiveButton] = useState(null);
    const { setQuestionIndex, answers, setAnswers } = useContext(QuizContext);

    function toNextScreen() {
        setQuestionIndex((prev) => prev + 1);
        setAnswers({
            ...answers,
            question4: buttons[activeButton].answerLabel,
        });
    }

    return (
        <div styleName="permission">
            <div styleName="title">
                <h2>Ben je al in het bezit van een bevoegdheid?</h2>
                <ProgressBar />
            </div>
            <div styleName="question">
                <div styleName="image-wrapper">
                    <img
                        src="/images/test/images/bevoegdheid.jpg"
                        alt="person-thinking"
                    />
                </div>
                <div styleName="buttons">
                    {buttons.map((button, index) => (
                        <CircleButton
                            onClick={() => {
                                setActiveButton(index);
                            }}
                            active={activeButton === index}
                            key={index}
                            description={button?.description}
                            icon={button?.icon}
                        />
                    ))}
                </div>
            </div>
            <div styleName="bottom-button-wrapper">
                <Button
                    color="blue-gray"
                    onClick={() => setQuestionIndex((prev) => prev - 1)}
                >
                    <FontAwesomeIcon icon={faArrowLeft} />
                    Vorige
                </Button>
                <Tooltip
                    // theme="light"
                    disabled={activeButton !== null}
                    style={{ width: 'fit-content' }}
                    title="Je hebt nog geen antwoord ingevuld"
                >
                    <Button
                        color="blue"
                        disabled={activeButton === null}
                        icon={faArrowRight}
                        onClick={toNextScreen}
                    >
                        Volgende
                    </Button>
                </Tooltip>
            </div>
        </div>
    );
}
